<template>
    <el-card
        v-if="element"
        :body-style="{ padding: '1rem 0' }"
        style="margin: 1rem 1rem 1rem 1rem"
        shadow="never"
    >
        <VuePerfectScrollbar
            class="d-flex flex-column p-5"
            style="height: calc(100dvh - 11.7rem)"
        >
            <div class="pt-5 pt-5" id="invoice" style="min-width: 25cm; min-height: 29.7cm;">
                <div class="d-flex flex-row">
                    <div class="d-flex flex-column col-4 p-0">
                        <div>
                            <img
                                src="/static/image/Gpuhub-logo-text.svg"
                                height="30"
                            />
                        </div>
                        <div class="invoice-title-large mt-3">
                            {{ $t('invoice.accountNumber') }}
                        </div>
                        <div class="invoice-text-normal">
                            {{ user.username }}
                        </div>
                        <div class="invoice-text-normal mt-3">
                            <div class="invoice-title-large">
                                {{ $t('invoice.billToAddress') }}
                            </div>
                            <div>
                                {{ $t('invoice.nameLabel') }}&nbsp;&nbsp;&nbsp;{{ element.billingName }}
                            </div>
                            <div>
                                {{ $t('invoice.addressLabel') }}&nbsp;&nbsp;&nbsp;{{
                                    element.billingAddress
                                }}
                            </div>
                            <div>
                                {{ $t('invoice.phoneLabel') }}&nbsp;&nbsp;&nbsp;{{
                                    element.billingPhone
                                }}
                            </div>
                            <div>
                                {{ $t('invoice.taxCodeLabel') }}&nbsp;&nbsp;&nbsp;{{
                                    element.billingTaxCode
                                }}
                            </div>
                        </div>
                    </div>
                    <div class="flex-fill ml-5">
                        <div class="invoice-title-large">
                            {{ $t('invoice.companyInvoiceTitle') }}
                        </div>
                        <div
                            style="border-bottom: 2px solid #42a5f5"
                            class="invoice-text-normal mt-1"
                        >
                            {{ $t('invoice.contactLine') }}
                        </div>
                        <div
                            style="border-bottom: 1px solid #42a5f5"
                            class="invoice-title-large mt-2"
                        >
                            {{ $t('invoice.invoiceSummary') }}
                        </div>
                        <div
                            style="border-bottom: 1px solid #42a5f5"
                            class="invoice-text-normal mt-2"
                        >
                            <div class="d-flex justify-content-between">
                                <div>{{ $t('invoice.invoiceNumber') }}</div>
                                <div>
                                    <span>{{ element.code }}</span>
                                </div>
                            </div>
                            <div class="d-flex justify-content-between mt-1">
                                <div>{{ $t('invoice.invoiceDate') }}</div>
                                <div>{{ element.transAt | DateTime }} UTC</div>
                            </div>
                        </div>
                        <div
                            style="border-bottom: 2px solid #42a5f5"
                            class="d-flex justify-content-between mt-2"
                        >
                            <div class="invoice-title-large">
                                {{ $t('invoice.totalPaymentAmount') }}
                            </div>
                            <div class="invoice-title-large">
                                <span v-if="element.irenderPointCharged">
                                    <span>{{
                                        element.irenderPointCharged
                                    }}</span>
                                    <span>&nbsp;iRp</span></span
                                >
                                <span
                                    v-if="
                                        element.irenderPointCharged &&
                                        element.bonusPointCharged
                                    "
                                    class="ml-3 mr-3"
                                    >+</span
                                >
                                <span v-if="element.bonusPointCharged">
                                    <span>{{ element.bonusPointCharged }}</span>
                                    <span>&nbsp;Bp</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="mt-3">
                    <div
                        style="font-weight: 400; color: #212121"
                        class="invoice-text-large"
                    >
                        {{ $t('invoice.billingMachineId') }}
                        <span>{{ element.machineId }}</span>
                        <span>&nbsp;({{ element.machineName }})</span>
                    </div>
                    <div class="invoice-text-normal">
                        {{ $t('invoice.greeting') }}
                    </div>
                </div>
                <div class="mt-5">
                    <div style="border: 2px solid #90caf9">
                        <div class="cell title-table">{{ $t('invoice.summary') }}</div>
                        <div class="cell">
                            <div class="title-service">{{ $t('invoice.irenderCharges') }}</div>
                            <div class="invoice-text-normal">
                                <span v-if="element.irenderPointCharged">
                                    <span>{{
                                        element.irenderPointCharged
                                    }}</span>
                                    <span>&nbsp;iRp</span>
                                </span>
                                <span
                                    v-if="
                                        element.irenderPointCharged &&
                                        element.bonusPointCharged
                                    "
                                    class="ml-3 mr-3"
                                    >+</span
                                >
                                <span v-if="element.bonusPointCharged">
                                    <span>{{ element.bonusPointCharged }}</span>
                                    <span>&nbsp;Bp</span>
                                </span>
                            </div>
                        </div>
                        <div class="invoice-text-normal">
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.charges') }}</div>
                                <div>
                                    <span v-if="element.irenderPointCharged">
                                        <span>{{
                                            element.irenderPointCharged
                                        }}</span>
                                        <span>&nbsp;iRp</span>
                                    </span>
                                    <span
                                        v-if="
                                            element.irenderPointCharged &&
                                            element.bonusPointCharged
                                        "
                                        class="ml-3 mr-3"
                                        >+</span
                                    >
                                    <span v-if="element.bonusPointCharged">
                                        <span>{{
                                            element.bonusPointCharged
                                        }}</span>
                                        <span>&nbsp;Bp</span>
                                    </span>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.credits') }}</div>
                                <div>
                                    <span>0.0</span>
                                    <span>&nbsp;iRp</span>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.tax') }}</div>
                                <div>
                                    <span>0.0</span>
                                    <span>&nbsp;iRp</span>
                                </div>
                            </div>
                            <div style="background-color: #fff3e0" class="cell">
                                <div class="title-total">
                                    {{ $t('invoice.totalForInvoice') }}
                                </div>
                                <div>
                                    <span v-if="element.irenderPointCharged">
                                        <span>{{
                                            element.irenderPointCharged
                                        }}</span>
                                        <span>&nbsp;iRp</span>
                                    </span>
                                    <span
                                        v-if="
                                            element.irenderPointCharged &&
                                            element.bonusPointCharged
                                        "
                                        class="ml-3 mr-3"
                                        >+</span
                                    >
                                    <span v-if="element.bonusPointCharged">
                                        <span>{{
                                            element.bonusPointCharged
                                        }}</span>
                                        <span>&nbsp;Bp</span>
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-5" style="border: 2px solid #90caf9">
                        <div class="cell title-table">{{ $t('invoice.detail') }}</div>
                        <div class="cell">
                            <div class="title-service">
                                <span
                                    >{{ $t('invoice.gpuhubService', { plan: element.fixedRental
                                            ? $t('bootMachine.rentalPlan')
                                            : $t('bootMachine.payAsYouGo') }) }}</span
                                >
                            </div>
                            <div class="invoice-text-normal">
                                <span v-if="element.irenderPointCharged">
                                    <span>{{
                                        element.irenderPointCharged
                                    }}</span>
                                    <span>&nbsp;iRp</span>
                                </span>
                                <span
                                    v-if="
                                        element.irenderPointCharged &&
                                        element.bonusPointCharged
                                    "
                                    class="ml-3 mr-3"
                                    >+</span
                                >
                                <span v-if="element.bonusPointCharged">
                                    <span>{{ element.bonusPointCharged }}</span>
                                    <span>&nbsp;Bp</span>
                                </span>
                            </div>
                        </div>
                        <div class="invoice-text-normal">
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.price') }}</div>
                                <div>
                                    <span>{{ element.price }} {{ $t('rentalInfo.pointLabel') }}</span>
                                    <span class="ml-1 mr-1">/</span>
                                    <span>{{ element.unit }}</span>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">
                                    {{
                                        element.fixedRental
                                            ? $t('invoice.startDate')
                                            : $t('billingItem.startTime')
                                    }}
                                </div>
                                <div>
                                    <span
                                        >{{
                                            element.startTime | DateTime
                                        }}
                                        UTC</span
                                    >
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">
                                    {{
                                        element.fixedRental
                                            ? $t('invoice.endDate')
                                            : $t('billingItem.endTime')
                                    }}
                                </div>
                                <div>
                                    <span
                                        >{{
                                            element.endTime | DateTime
                                        }}
                                        UTC</span
                                    >
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">{{ $t('billingItem.duration') }}</div>
                                <div>{{ element.durationDescription }}</div>
                            </div>
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.charges') }}</div>
                                <div>
                                    <span v-if="element.irenderPointCharged">
                                        <span>{{
                                            element.irenderPointCharged
                                        }}</span>
                                        <span>&nbsp;iRp</span>
                                    </span>
                                    <span
                                        v-if="
                                            element.irenderPointCharged &&
                                            element.bonusPointCharged
                                        "
                                        class="ml-3 mr-3"
                                        >+</span
                                    >
                                    <span v-if="element.bonusPointCharged">
                                        <span>{{
                                            element.bonusPointCharged
                                        }}</span>
                                        <span>&nbsp;Bp</span>
                                    </span>
                                </div>
                            </div>
                            <div class="cell">
                                <div class="title-details">{{ $t('invoice.vat') }}</div>
                                <div>
                                    <span>0.0</span>
                                    <span>&nbsp;iRp</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div
                    class="invoice-text-small d-flex flex-row"
                    style="margin-top: 2.5rem"
                >
                    <div class="col-7 p-0">
                        <div>
                            {{ $t('invoice.disclaimer') }}
                        </div>
                        <div>
                            {{ $t('invoice.priceInIrp') }}
                        </div>
                        <div>
                            {{ $t('invoice.soldBy') }}
                        </div>
                    </div>
                    <div class="col-2"></div>
                    <div class="col-3 p-0">
                        <div>{{ $t('invoice.serviceProvider') }}</div>
                        <div>{{ $t('invoice.notForRemittance') }}</div>
                        <div>{{ $t('invoice.companyName') }}</div>
                        <div>
                            {{ $t('invoice.companyAddress') }}
                        </div>
                        <div>{{ $t('invoice.companyCity') }}</div>
                    </div>
                </div>
            </div>
        </VuePerfectScrollbar>
    </el-card>
</template>

<script>
// CSS
import "@/assets/css/invoice.scss";

//Lib
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },

    props: {
        element: {
            type: Object,
            default() {
                return {};
            },
        },
    },

    mounted() {
        console.log(this.element);
    },
};
</script>